import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

export const Preloader = () => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 950);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <>
          <motion.div
            key="curtain-back"
            aria-hidden="true"
            className="fixed inset-0 z-[99] bg-gb-graphite"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.6, delay: 0.1, ease: EASE }}
          />
          <motion.div
            key="curtain-front"
            data-testid="preloader"
            aria-hidden="true"
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-gb-black"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.55, ease: EASE }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              className="relative"
            >
              <img
                src="/assets/logo.jpg"
                alt=""
                width={88}
                height={88}
                className="h-20 w-20 rounded-full ring-1 ring-white/20 sm:h-24 sm:w-24"
              />
              <motion.span
                className="absolute -inset-2 rounded-full border border-gb-silver/40"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: [0.8, 1.15, 1.28], opacity: [0, 0.8, 0] }}
                transition={{ duration: 0.9, delay: 0.15, times: [0, 0.5, 1], ease: "easeOut" }}
              />
            </motion.div>

            <div className="mt-7 flex overflow-hidden font-display text-3xl font-extrabold tracking-[0.18em] sm:text-4xl">
              {"GOBAX".split("").map((letter, i) => (
                <motion.span
                  key={i}
                  initial={{ y: "110%", opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.45, delay: 0.18 + i * 0.05, ease: [0.16, 1, 0.3, 1] }}
                  className={i >= 3 ? "chrome-text" : "text-gb-white"}
                >
                  {letter}
                </motion.span>
              ))}
            </div>

            <div className="mt-7 h-px w-44 overflow-hidden rounded-full bg-white/10">
              <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: "0%" }}
                transition={{ duration: 0.7, ease: [0.65, 0, 0.35, 1] }}
                className="h-full w-full bg-gradient-to-r from-gb-silver/40 via-gb-silverhi to-gb-silver/40"
              />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
